import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../utils/shared.modules';

import {CustomAgGridModule} from '../../utils/ag-grid/custom-ag-grid.module';

import {InscriptionComponent} from './inscription/inscription.component';
import {SidebarComponent} from '../sidebar/sidebar.component';
import {
    InscriptionAddSuppRegisterEventComponent
} from './inscription-add-supp-register-event/inscription-add-supp-register-event.component';
import {YoungCreationDataService} from '../../services/young-creation-data.service';
import {
    InscriptionInformationYoungComponent
} from './inscription-information-young/inscription-information-young.component';
import {SchoolLevelInputComponent} from './inscription/school-level-input/school-level-input.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

const PAGES_COMPONENT = [
    InscriptionComponent,
    SidebarComponent,
    InscriptionInformationYoungComponent,
    SchoolLevelInputComponent
];


@NgModule({
    imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    CustomAgGridModule,
    MatSlideToggleModule,
    ...PAGES_COMPONENT, InscriptionAddSuppRegisterEventComponent
],
    exports: [],
    providers: [YoungCreationDataService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InscriptionModule {
}
